// Die Erlaeuterung unter der Monatsauswahl folgt der Auswahl. Der Zeitraum-Text haengt fertig
// formatiert an jeder Option (data-period), damit hier keine Datums-Formatierung nachgebaut wird.
$(document).on('change', '.billing-month-select', function() {
  var period = $(this).find('option:selected').data('period');

  if (period) {
    $('#billing-month-hint').text(period);
  }
})
